import BaseModel from '../core/BaseModel'
//import GroupModel from "@/models/GroupModel";
//import gql from 'graphql-tag'
export default class AdminModel extends BaseModel {

    constructor() {
        super({ 
                name: "view_admin",
                tableName: 'view_admin',
                label: "Administrator Management",
                display_key: 'fullname', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "No.",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
                avatar: {
                    name: "avatar",
                    label: "Avatar",
                    custom: 'image',
                    type: "Computed",
                    computed: (data, index) => {
                        data.avatar = index + 1;
                    },
                    //display: false,
                },
                fullname: {
                    name: 'fullname',
                    type: "String",
                    label: 'Fullname',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                email: {
                    name: 'email',
                    type: "String",
                    label: 'Email',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                phone: {
                    name: 'phone',
                    type: "String",
                    label: 'Phone number',
                    class:"small-col-midle txt-left",
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                account: {
                    name: 'account',
                    type: "String",
                    label: 'Username',
                    sortable: false,
                    class:"small-col-midle txt-left",
                    width: 10,
                    filter: {type: 'input', match: 'contains'},
                },
                role: {
                    name: "role",
                    label: "Type",
                    type: "Selection",
                    custom: 'SelectionText',
                    class:"small-col-midle  txt-left",
                    options: [
                        { value: 'admin_child', label: 'Admininstrator', style: 'color:  #000000;' },
                        { value: 'care', label: 'Saleperson', style: 'color:  #000000;' }
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    width: 8,
                },
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    class:"small-col-midle  txt-left",
                    options: [
                        { value: 'true', label: 'Yes', style: 'color:  #000000;' },
                        { value: 'false', label: 'No', style: 'color:  #000000;' }
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    width: 8,
                },
                /*updated_by_key: {
                    name: "updated_by_key",
                    label: "Updated by",
                    type: "Computed",
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.updated_by_key ='' ;
                    },
                },*/
                updated_at : {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Updated date',
                    class:"small-col-midle txt-left",
                    filter: { type: 'DateRange', match: 'contains'}
                },
                detail_get: {
                    refs:  'role is_chat_unassigned note ',
                    display: false
                },
        },)
    }

}
